import { useEffect, useRef } from 'react'
import CloseIcon from '@mui/icons-material/Close'

// Een ingestuurde foto over het hele venster, op de tab 'Te beoordelen'.
// Bewust geen requestFullscreen: Chrome weigerde dat ("not granted") en gooide
// een onopgevangen fout (Chrome-check 2026-11-02). En geen common/Modal: die
// heeft een kop en knoppenbalk, hier hoort alleen de foto.
// Sluiten: het kruisje, Esc, of een klik op de foto of het zwarte vlak.

/**
 * @param {object} props
 * @param {string} props.src - Url van de foto
 * @param {string} props.alt - Beschrijving van de foto
 * @param {() => void} props.onClose - Sluit de weergave
 */
const StorytellingPhotoZoom = ({ src, alt, onClose }) => {
    /** @type {React.RefObject<HTMLButtonElement>} */
    const closeRef = useRef(null)

    useEffect(() => {
        if (closeRef.current) closeRef.current.focus()
        /** @param {KeyboardEvent} e */
        const keyHandler = (e) => {
            if (e.key === 'Escape') onClose()
        }
        document.addEventListener('keydown', keyHandler)
        return () => document.removeEventListener('keydown', keyHandler)
    }, [onClose])

    return (
        <div className="storytelling-zoom" role="dialog" aria-modal="true" aria-label="Foto schermvullend" onClick={onClose}>
            <img className="storytelling-zoom-photo" src={src} alt={alt} />
            <button ref={closeRef} type="button" className="storytelling-zoom-close" aria-label="Sluiten" title="Sluiten" onClick={onClose}>
                <CloseIcon aria-hidden="true" />
            </button>
        </div>
    )
}

export default StorytellingPhotoZoom
